import { Button, ButtonVariant } from 'smoothie';

import { ConversationalMMAnalyticsEvent } from '../analytics/events';
import { useConversationalMMContext } from '../context/ConversationalMMContextBase';

export const SlideNextButton = () => {
    const { slideIndex, setSlideIndex, slides, lastIndex, onTrackEvent } =
        useConversationalMMContext();

    const nextIndex = slideIndex + 1;
    const nextSlideName = slides[nextIndex]?.name ?? '';
    const currentSlideName = slides[slideIndex]?.name ?? '';

    return nextIndex <= lastIndex ? (
        <Button
            variant={ButtonVariant.SECONDARY}
            text={`Next: ${nextSlideName}`}
            onPress={() => {
                onTrackEvent(
                    ConversationalMMAnalyticsEvent.SlideNextButtonPressed,
                    {
                        fromSlide: currentSlideName,
                        fromSlideIndex: slideIndex,
                    },
                );
                setSlideIndex(nextIndex);
            }}
        />
    ) : null;
};
